"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createScribeLogger = (scribeUrl) => {
    return {
        log: (logJect) => {
            if (process.env.REACT_APP_DISABLE_SCRIBE === 'true') {
                return;
            }
            try {
                fetch(`${scribeUrl}/RecordLog`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(logJect),
                });
            }
            catch (e) {
                // Not really a big deal if it fails since we will get warnings when logs fail to show up
                // after X amount of time
                console.log('Error shipping logs', e);
            }
        },
    };
};
exports.default = createScribeLogger;
//# sourceMappingURL=createScribeLogger.js.map